(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lip-product-showcase"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('[data-lip-product]').forEach(function(section) {
    const variantId = section.querySelector('[data-lip-variant-id]')?.value;
    const gallery = section.querySelector('[data-lip-gallery]');
    if (!variantId || !gallery) return;
    const custom = Array.from(gallery.querySelectorAll('[data-variant-media="true"]')).filter(item => item.dataset.variantIds.split('|').includes(variantId));
    if (custom.length) {
      gallery.querySelectorAll('[data-lip-gallery-image]').forEach(item => { item.hidden = !custom.includes(item); });
      section.querySelectorAll('[data-lip-thumb]').forEach(item => { item.hidden = !(item.dataset.variantMedia === 'true' && item.dataset.variantIds.split('|').includes(variantId)); });
      gallery.hidden = false;
      section.querySelector('[data-lip-art]').hidden = true;
    }
    const firstThumb = section.querySelector('[data-lip-thumb]:not([hidden])');
    if (firstThumb) firstThumb.classList.add('is-active');
  });
});

document.addEventListener('click', function(event) {
  const button = event.target.closest('[data-lip-product] [data-variant-id]');
  if (!button) return;
  const section = button.closest('[data-lip-product]');
  const form = section.querySelector('form');
  const variantInput = form.querySelector('[data-lip-variant-id]');
  const price = section.querySelector('[data-lip-price]');
  const submitPrice = section.querySelector('[data-lip-submit-price]');
  const submitLabel = section.querySelector('[data-lip-submit-label]');
  const submit = section.querySelector('[data-lip-submit]');
  const selected = section.querySelector('[data-lip-selected]');
  section.querySelectorAll('[data-variant-id]').forEach(function(item) {
    const active = item === button;
    item.classList.toggle('is-selected', active);
    item.setAttribute('aria-pressed', active ? 'true' : 'false');
  });
  variantInput.value = button.dataset.variantId;
  const gallery = section.querySelector('[data-lip-gallery]');
  const art = section.querySelector('[data-lip-art]');
  let hasVisibleImage = false;
  gallery.querySelectorAll('[data-lip-gallery-image]').forEach(function(item) {
    const shared = item.dataset.shared === 'true';
    const variantIds = item.dataset.variantIds.split('|').filter(Boolean);
    const visible = shared || variantIds.includes(button.dataset.variantId);
    item.hidden = !visible;
    if (visible) hasVisibleImage = true;
  });
  const hasCustomVariantMedia = Array.from(gallery.querySelectorAll('[data-variant-media="true"]')).some(item => item.dataset.variantIds.split('|').includes(button.dataset.variantId));
  if (hasCustomVariantMedia) {
    gallery.querySelectorAll('[data-lip-gallery-image]').forEach(function(item) {
      if (item.dataset.variantMedia !== 'true') item.hidden = true;
    });
    hasVisibleImage = true;
  }
  gallery.hidden = !hasVisibleImage;
  art.hidden = hasVisibleImage;
  const pageUrl = new URL(window.location.href);
  pageUrl.searchParams.set('variant', button.dataset.variantId);
  window.history.replaceState({}, '', pageUrl.toString());
  selected.textContent = button.dataset.variantTitle;
  price.textContent = button.dataset.variantPrice;
  if (submitPrice) submitPrice.textContent = button.dataset.variantPrice;
  const available = button.dataset.variantAvailable === 'true';
  submit.disabled = !available;
  submitLabel.textContent = available ? submit.dataset.buyLabel : 'TILLFÄLLIGT SLUT';
  const options = section.querySelector('[data-lip-shade-options]');
  const toggle = section.querySelector('[data-lip-shade-toggle]');
  if (options) options.hidden = true;
  if (toggle) toggle.setAttribute('aria-expanded', 'false');
  section.querySelectorAll('[data-lip-thumb]').forEach(function(item) {
    const shared = item.dataset.shared === 'true';
    const variantIds = item.dataset.variantIds.split('|').filter(Boolean);
    item.hidden = !(shared || variantIds.includes(button.dataset.variantId));
  });
  if (hasCustomVariantMedia) {
    section.querySelectorAll('[data-lip-thumb]').forEach(function(item) {
      if (item.dataset.variantMedia !== 'true') item.hidden = true;
    });
  }
  const firstThumb = section.querySelector('[data-lip-thumb]:not([hidden])');
  section.querySelectorAll('[data-lip-thumb]').forEach(item => item.classList.toggle('is-active',item===firstThumb));
  if (gallery) gallery.scrollLeft = 0;
});

document.addEventListener('click', function(event) {
  const toggle = event.target.closest('[data-lip-shade-toggle]');
  if (toggle) {
    const section = toggle.closest('[data-lip-product]');
    const options = section.querySelector('[data-lip-shade-options]');
    options.hidden = !options.hidden;
    toggle.setAttribute('aria-expanded', String(!options.hidden));
    return;
  }
  const thumb = event.target.closest('[data-lip-thumb]');
  if (thumb) {
    const section = thumb.closest('[data-lip-product]');
    const images = Array.from(section.querySelectorAll('[data-lip-gallery-image]:not([hidden])'));
    const thumbs = Array.from(section.querySelectorAll('[data-lip-thumb]:not([hidden])'));
    const index = thumbs.indexOf(thumb);
    if (images[index]) images[index].scrollIntoView({behavior:'smooth',block:'nearest',inline:'start'});
    thumbs.forEach(t => t.classList.toggle('is-active',t===thumb));
    return;
  }
  const arrow = event.target.closest('[data-lip-prev], [data-lip-next]');
  if (arrow) {
    const section = arrow.closest('[data-lip-product]');
    const gallery = section.querySelector('[data-lip-gallery]');
    const images = Array.from(gallery.querySelectorAll('[data-lip-gallery-image]:not([hidden])'));
    if (!images.length) return;
    const active = images.reduce((best,img,i)=>Math.abs(img.offsetLeft-gallery.scrollLeft)<Math.abs(images[best].offsetLeft-gallery.scrollLeft)?i:best,0);
    const next = Math.max(0,Math.min(images.length-1,active+(arrow.hasAttribute('data-lip-next')?1:-1)));
    images[next].scrollIntoView({behavior:'smooth',block:'nearest',inline:'start'});
    return;
  }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-comparison-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setupCarousel = (root) => {
      if (!root || root.dataset.comparisonReady === 'true') return;

      const viewport = root.querySelector('[data-comparison-viewport]');
      const track = root.querySelector('[data-comparison-track]');
      const arrows = root.querySelectorAll('[data-comparison-direction]');

      if (!viewport || !track) return;

      root.dataset.comparisonReady = 'true';

      const getStep = () => {
        const card = track.querySelector('.product-comparison__card');
        if (!card) return viewport.clientWidth;

        const styles = window.getComputedStyle(track);
        const gap = parseFloat(styles.columnGap || styles.gap) || 0;
        return card.getBoundingClientRect().width + gap;
      };

      const updateArrows = () => {
        const maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
        arrows.forEach((arrow) => {
          const direction = Number(arrow.dataset.comparisonDirection);
          arrow.disabled = direction < 0
            ? viewport.scrollLeft <= 2
            : viewport.scrollLeft >= maxScroll - 2;
        });
      };

      const syncRowHeights = () => {
        const rows = [1, 2, 3];

        rows.forEach((row) => {
          root.style.removeProperty(`--pc-row-${row}-height`);
        });

        rows.forEach((row) => {
          const cells = root.querySelectorAll(`[data-comparison-row="${row}"]`);
          const height = Math.max(...Array.from(cells, (cell) => {
            const cellStyles = window.getComputedStyle(cell);
            const label = cell.querySelector('.product-comparison__label');
            const value = cell.querySelector('.product-comparison__value');
            const labelStyles = label ? window.getComputedStyle(label) : null;
            const verticalSpacing =
              parseFloat(cellStyles.paddingTop) +
              parseFloat(cellStyles.paddingBottom) +
              parseFloat(cellStyles.borderTopWidth) +
              parseFloat(cellStyles.borderBottomWidth);
            const labelHeight = label ? label.scrollHeight : 0;
            const labelMargin = labelStyles ? parseFloat(labelStyles.marginBottom) : 0;
            const valueHeight = value ? value.scrollHeight : 0;

            return verticalSpacing + labelHeight + labelMargin + valueHeight;
          }));

          if (Number.isFinite(height)) {
            root.style.setProperty(`--pc-row-${row}-height`, `${Math.ceil(height)}px`);
          }
        });
      };

      arrows.forEach((arrow) => {
        arrow.addEventListener('click', () => {
          const direction = Number(arrow.dataset.comparisonDirection);
          viewport.scrollBy({
            left: getStep() * direction,
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
          });
        });
      });

      let pointerIsDown = false;
      let pointerStartX = 0;
      let pointerStartScroll = 0;
      let dragMoved = false;

      viewport.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        if (event.target instanceof Element && event.target.closest('a, button')) return;

        pointerIsDown = true;
        dragMoved = false;
        pointerStartX = event.clientX;
        pointerStartScroll = viewport.scrollLeft;
        viewport.setPointerCapture(event.pointerId);
        viewport.classList.add('is-dragging');
      });

      viewport.addEventListener('pointermove', (event) => {
        if (!pointerIsDown) return;

        const distance = event.clientX - pointerStartX;
        if (Math.abs(distance) > 4) dragMoved = true;
        viewport.scrollLeft = pointerStartScroll - distance;
      });

      const releasePointer = (event) => {
        if (!pointerIsDown) return;

        pointerIsDown = false;
        if (viewport.hasPointerCapture(event.pointerId)) {
          viewport.releasePointerCapture(event.pointerId);
        }
        viewport.classList.remove('is-dragging');
        updateArrows();
      };

      viewport.addEventListener('pointerup', releasePointer);
      viewport.addEventListener('pointercancel', releasePointer);
      viewport.addEventListener('dragstart', (event) => event.preventDefault());
      viewport.addEventListener('click', (event) => {
        if (!dragMoved) return;

        event.preventDefault();
        event.stopPropagation();
        dragMoved = false;
      }, true);

      let frame;
      viewport.addEventListener('scroll', () => {
        window.cancelAnimationFrame(frame);
        frame = window.requestAnimationFrame(updateArrows);
      }, { passive: true });

      let resizeFrame;
      window.addEventListener('resize', () => {
        window.cancelAnimationFrame(resizeFrame);
        resizeFrame = window.requestAnimationFrame(() => {
          syncRowHeights();
          updateArrows();
        });
      }, { passive: true });

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(syncRowHeights);
      }

      new ResizeObserver(updateArrows).observe(viewport);
      syncRowHeights();
      updateArrows();
    };

    document.querySelectorAll('[data-product-comparison]').forEach(setupCarousel);

    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target.matches('[data-product-comparison]')
        ? event.target
        : event.target.querySelector('[data-product-comparison]');
      setupCarousel(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-in-kits"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ssl-product-in-kits')) {
    customElements.define('ssl-product-in-kits', class extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('ul');
        this.buttons = [...this.querySelectorAll('[data-kit-direction]')];
        this.update = () => {
          const first = this.list.firstElementChild?.getBoundingClientRect();
          const last = this.list.lastElementChild?.getBoundingClientRect();
          const viewport = this.list.getBoundingClientRect();
          const rtl = getComputedStyle(this.list).direction === 'rtl';
          this.buttons[0].disabled = !first || (rtl ? first.right <= viewport.right + 2 : first.left >= viewport.left - 2);
          this.buttons[1].disabled = !last || (rtl ? last.left >= viewport.left - 2 : last.right <= viewport.right + 2);
        };
        this.click = event => {
          const button = event.target.closest('[data-kit-direction]');
          if (!button || !this.contains(button)) return;
          const width = this.list.firstElementChild?.getBoundingClientRect().width || 250;
          const gap = parseFloat(getComputedStyle(this.list).columnGap) || 0;
          const direction = getComputedStyle(this.list).direction === 'rtl' ? -1 : 1;
          this.list.scrollBy({left: (width + gap) * Number(button.dataset.kitDirection) * direction, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
        };
        this.addEventListener('click', this.click);
        this.list.addEventListener('scroll', this.update, {passive: true});
        this.observer = new ResizeObserver(this.update);
        this.observer.observe(this.list);
        this.update();
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.click);
        this.list?.removeEventListener('scroll', this.update);
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skin-hair-calendar-waitlist"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeCountdowns = (root = document) => {
      root.querySelectorAll('[data-calendar-countdown]').forEach((countdown) => {
        if (countdown.dataset.countdownInitialized === 'true') return;

        const launchTime = new Date(countdown.dataset.launchAt).getTime();
        const units = countdown.querySelector('[data-countdown-units]');
        const completeMessage = countdown.querySelector('[data-countdown-complete]');
        const fields = {
          days: countdown.querySelector('[data-countdown-days]'),
          hours: countdown.querySelector('[data-countdown-hours]'),
          minutes: countdown.querySelector('[data-countdown-minutes]'),
          seconds: countdown.querySelector('[data-countdown-seconds]')
        };

        if (Number.isNaN(launchTime)) {
          countdown.hidden = true;
          return;
        }

        countdown.dataset.countdownInitialized = 'true';
        let countdownTimer;

        const updateCountdown = () => {
          const remaining = launchTime - Date.now();

          if (remaining <= 0) {
            units.hidden = true;
            completeMessage.hidden = false;
            window.clearInterval(countdownTimer);
            return;
          }

          fields.days.textContent = Math.floor(remaining / 86400000);
          fields.hours.textContent = String(Math.floor((remaining % 86400000) / 3600000)).padStart(2, '0');
          fields.minutes.textContent = String(Math.floor((remaining % 3600000) / 60000)).padStart(2, '0');
          fields.seconds.textContent = String(Math.floor((remaining % 60000) / 1000)).padStart(2, '0');
        };

        updateCountdown();
        if (!units.hidden) {
          countdownTimer = window.setInterval(updateCountdown, 1000);
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeCountdowns());
    } else {
      initializeCountdowns();
    }

    document.addEventListener('shopify:section:load', (event) => initializeCountdowns(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
